import React from 'react';
import { landingImages, LandingSvg } from 'assets';

export const abaCardsInfo = (width) => {
    return [
        {
            iconInfo: {
                background: '#DBEAFE',
                Icon: <landingImages.PManagementSvg />,
                padding: width > 1289 ? '16px' : '10px',
            },
            title: 'Practice Management',
            text: 'Streamline scheduling, billing, and compliance in one place. Keep your entire team organized and your practice running efficiently',
            border: '1px solid #DBEAFE',
            background: 'linear-gradient(135deg, #EFF6FF 0%, #FFF 70.71%)',
        },

        {
            iconInfo: {
                background: '#F3E8FF',
                Icon: <landingImages.DataCollSvg />,
                padding: width > 1289 ? '14px 17px' : '8.75px 10.62px',
            },
            title: 'Data Collection',
            text: 'Track behavior data in real time, customize programs, and instantly visualize client progress - all with mobile-first tools built for therapists',
            border: '1px solid #F3E8FF',
            background: 'linear-gradient(135deg, #FAF5FF 0%, #FFF 70.71%)',
        },

        {
            iconInfo: {
                background: '#DCFCE7',
                Icon: <landingImages.RCycleSvg />,
                padding: width > 1289 ? '14px 22.6px' : '8.75px 14px',
            },
            title: 'Revenue Cycle Management',
            text: 'Simplify billing and claims with automated processes that reduce errors, speed up reimbursements, and improve cash flow',
            border: '1px solid #DCFCE7',
            background: 'linear-gradient(135deg, #F0FDF4 0%, #FFF 70.71%)',
        },
    ];
};

export const slideCompleteABAContents = [
    {
        title: 'Smart Scheduling & Calendar Sync',
        text: 'Unified calendar for all sessions and changes - easy viewing and management at a glance',
        image: landingImages.smartScheduling,
    },
    {
        title: 'Authorization & Compliance Tracking',
        text: 'Get alerts before authorizations expire and stay audit-ready with built-in compliance tools',
        image: landingImages.authorizationComplianceTracking,
    },
    {
        title: 'Billing & Claims Automation',
        text: 'Automated claims with error checks and real-time statuses for faster reimbursements',
        image: landingImages.billingClaimsAutomation,
    },
    {
        title: 'Client & Staff Management',
        text: 'All client and staff details in one place - always connected and up to date',
        image: landingImages.clientStaffManagement,
    },
    {
        title: 'Task & Workflow Automation',
        text: 'Automated reminders, to-dos, and approvals that reduce admin work',
        image: landingImages.taskWorkflow,
    },
    {
        title: 'Reports & Insights Dashboard',
        text: 'Instant reports on scheduling, revenue, and progress - all in one dashboard',
        image: landingImages.reports,
    },
];

export const slideCompleteABAImages = [
    {
        image: landingImages.smartScheduling,
    },
    {
        image: landingImages.authorizationComplianceTracking,
    },
    {
        image: landingImages.billingClaimsAutomation,
    },
    {
        image: landingImages.clientStaffManagement,
    },
    {
        image: landingImages.taskWorkflow,
    },
    {
        image: landingImages.reports,
    },
];

export const slideDataCollectionContents = [
    {
        title: 'Mastery Tracking & Graphs',
        text: 'Automatically visualize progress toward goals',
        image: landingImages.masteryTracking,
    },

    {
        title: 'Integrated Notes & Signatures',
        text: 'Finish documentation without switching systems',
        image: landingImages.integratedNotes,
    },

    {
        title: 'Quick Session Workflow',
        text: 'Record targets, behaviors, and notes instantly',
        image: landingImages.quickSession,
    },

    {
        title: 'Templates & Prompt Hierarchies',
        text: 'Customize programs your way, 100% flexible',
        image: landingImages.templatesPrompt,
    },

    {
        title: 'Mobile-First Data Entry',
        text: 'Designed for therapists on the go',
        image: landingImages.mobileFirstData,
    },

    {
        title: 'Offline Mode with Auto-Sync',
        text: 'Keep working without internet interruption',
        image: landingImages.offlineMode,
    },
];

export const slideDataCollectionImages = [
    {
        image: landingImages.masteryTracking,
    },
    {
        image: landingImages.integratedNotes,
    },
    {
        image: landingImages.quickSession,
    },
    {
        image: landingImages.templatesPrompt,
    },
    {
        image: landingImages.mobileFirstData,
    },
    {
        image: landingImages.offlineMode,
    },
];

export const whyTherapyCardFirstData = [
    {
        Icon: LandingSvg.FreeMonthsSvg,
        hoverBlock: {
            background: '#1C2849',
            transition: 'all 0.2s',
        },
        hoverIcon: {
            borderColor: 'rgba(59, 130, 246, 0.20)',
            background: 'rgba(59, 130, 246, 0.10)',
            filter: 'brightness(0) saturate(100%) invert(61%) sepia(10%) saturate(2602%) hue-rotate(176deg) brightness(99%) contrast(99%)',
        },
        flag: 'Limited Offer',
        title: '2 Months Free',
        description: 'Experience the full power of TherapyLake with zero cost for your first quarter',
    },

    {
        Icon: LandingSvg.FreeOnboardingSvg,
        hoverBlock: {
            background: '#1B2C3D',
            transition: 'all 0.2s',
        },
        hoverIcon: {
            borderColor: 'rgba(34, 197, 94, 0.20)',
            background: 'rgba(34, 197, 94, 0.10)',
            filter: 'brightness(0) saturate(100%) invert(62%) sepia(88%) saturate(296%) hue-rotate(89deg) brightness(98%) contrast(98%)',
        },
        title: 'Free Onboarding',
        description: 'Our concierge team handles migration, training and setup so you can focus on care',
    },

    {
        Icon: LandingSvg.FreeDataTransferSvg,
        hoverBlock: {
            background: '#242447',
            transition: 'all 0.2s',
        },
        hoverIcon: {
            borderColor: 'rgba(168, 85, 247, 0.20)',
            background: 'rgba(168, 85, 247, 0.10)',
            filter: 'brightness(0) saturate(100%) invert(68%) sepia(89%) saturate(3003%) hue-rotate(220deg) brightness(100%) contrast(98%)',
        },
        title: 'Free Data Transfer',
        description: 'We securely migrate your existing data at no extra charge',
    },

    {
        Icon: LandingSvg.FreeSupportSvg,
        hoverBlock: {
            background: '#2A2B36',
            transition: 'all 0.2s',
        },
        hoverIcon: {
            borderColor: 'rgba(234, 179, 8, 0.20)',
            background: 'rgba(234, 179, 8, 0.10)',
            filter: 'brightness(0) saturate(100%) invert(82%) sepia(47%) saturate(888%) hue-rotate(341deg) brightness(102%) contrast(105%)',
        },
        title: 'Free Support',
        description: 'Enjoy unlimited access to our support team whenever you need help',
    },
];

export const whyTherapyCardSecondData = [
    {
        Icon: LandingSvg.DisconnectedSystemsSvg,
        title: 'Disconnected Systems',
        description: "Data doesn't sync between billing, EMR, and scheduling",
    },

    {
        Icon: LandingSvg.DataEntrySvg,
        title: 'Manual Data Entry',
        description: 'Wasted time and increased risk of human error',
    },

    {
        Icon: LandingSvg.PoorUserSvg,
        title: 'Poor User Experience',
        description: 'Clunky, outdated interfaces that frustrate your staff',
    },

    {
        Icon: LandingSvg.LimitedReportingSvg,
        title: 'Limited Reporting',
        description: "Lack of actionable insights into your practice's health",
    },

    {
        Icon: LandingSvg.HiddenFeesSvg,
        title: 'Hidden Fees',
        description: 'Multiple subscriptions and unexpected costs add up',
    },

    {
        Icon: LandingSvg.SlowSupportSvg,
        title: 'Slow Support',
        description: 'Long wait times for help with critical issues',
    },
];
